import { GentuLogo } from "@vitality-ds/icons";
import { CircleCheck, File, Inbox, Link2, Link2Off, Lock, LockOpen, Pencil, Plus, Printer, SendHorizontal, Trash2, Undo2 } from "lucide-react";
export var PREPOSITIONS = {
  by: "by",
  to: "to",
  from: "from",
  "for": "for"
};

// dear future contributor the below is alphabetically ordered
export var ACTIONS = {
  complete: {
    actionName: "Completed",
    preposition: PREPOSITIONS.by,
    fallbackIcon: CircleCheck,
    forceIcon: false
  },
  create: {
    actionName: "Created",
    preposition: PREPOSITIONS.by,
    fallbackIcon: Plus,
    forceIcon: false
  },
  "delete": {
    actionName: "Deleted",
    preposition: PREPOSITIONS.by,
    fallbackIcon: Trash2,
    forceIcon: false
  },
  edit: {
    actionName: "Edited",
    preposition: PREPOSITIONS.by,
    fallbackIcon: Pencil,
    forceIcon: false
  },
  finalise: {
    actionName: "Finalised",
    preposition: PREPOSITIONS.by,
    fallbackIcon: CircleCheck,
    forceIcon: false
  },
  linkBy: {
    actionName: "Linked",
    preposition: PREPOSITIONS.by,
    fallbackIcon: Link2,
    forceIcon: false
  },
  linkTo: {
    actionName: "Linked",
    preposition: PREPOSITIONS.to,
    fallbackIcon: Link2,
    forceIcon: true
  },
  print: {
    actionName: "Printed",
    preposition: PREPOSITIONS.by,
    fallbackIcon: Printer,
    forceIcon: true
  },
  receive: {
    actionName: "Received",
    preposition: PREPOSITIONS.by,
    fallbackIcon: Inbox,
    forceIcon: false
  },
  remove: {
    actionName: "Removed",
    preposition: PREPOSITIONS.by,
    fallbackIcon: Trash2,
    forceIcon: false
  },
  restrict: {
    actionName: "Restricted",
    preposition: PREPOSITIONS.by,
    fallbackIcon: Lock,
    forceIcon: false
  },
  restore: {
    actionName: "Restored",
    preposition: PREPOSITIONS.by,
    fallbackIcon: Undo2,
    forceIcon: false
  },
  review: {
    actionName: "Reviewed",
    preposition: PREPOSITIONS.by,
    fallbackIcon: File,
    forceIcon: false
  },
  sendBy: {
    actionName: "Sent",
    preposition: PREPOSITIONS.by,
    fallbackIcon: SendHorizontal,
    forceIcon: false
  },
  sendTo: {
    actionName: "Sent",
    preposition: PREPOSITIONS.to,
    fallbackIcon: SendHorizontal,
    forceIcon: true
  },
  unlinkBy: {
    actionName: "Unlinked",
    preposition: PREPOSITIONS.by,
    fallbackIcon: Link2Off,
    forceIcon: false
  },
  unlinkFrom: {
    actionName: "Unlinked",
    preposition: PREPOSITIONS.from,
    fallbackIcon: Link2Off,
    forceIcon: true
  },
  unrestrict: {
    actionName: "Unrestricted",
    preposition: PREPOSITIONS.by,
    fallbackIcon: LockOpen,
    forceIcon: false
  },
  update: {
    actionName: "Updated",
    preposition: PREPOSITIONS.by,
    fallbackIcon: Pencil,
    forceIcon: false
  },
  "void": {
    actionName: "Voided",
    preposition: PREPOSITIONS.by,
    fallbackIcon: Trash2,
    forceIcon: false
  }
};
export var TITLES_TO_IGNORE = ["dr", "mr", "mrs", "ms", "miss", "prof", "mx", "dr.", "mr.", "mrs.", "ms.", "miss.", "prof.", "mx."];
export var APPLICATION_ICON_TRIGGERS = ["gentu"];
export var BRAND_ICONS = {
  gentu: GentuLogo
};